import { useOutletContext } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function GameShell({ title, subtitle, accent = "#FFC107", children, aside }) {
  const { user } = useAuth();
  const { openAuth } = useOutletContext() || {};
  return (
    <div className="flex flex-col gap-5 fade-up">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="chip mb-2" style={{ color: accent, borderColor: `${accent}55` }}>
            Provably Fair
          </div>
          <h1 className="font-display text-3xl md:text-4xl font-black tracking-tighter">{title}</h1>
          {subtitle && <div className="text-zinc-500 text-sm mt-1">{subtitle}</div>}
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_380px] gap-5">
        <div className="panel p-5 md:p-7 min-h-[500px] relative overflow-hidden">
          {!user && (
            <div className="absolute inset-0 z-20 flex items-center justify-center backdrop-blur-sm bg-black/40">
              <div className="text-center">
                <div className="font-display text-xl font-black">Sign in to play</div>
                <div className="text-sm text-zinc-500 mt-1">1,000 FMI signup bonus awaits.</div>
                <button onClick={openAuth} className="btn-gold rounded-xl px-5 py-2.5 mt-4" data-testid="game-signin-btn">
                  Enter the Vault
                </button>
              </div>
            </div>
          )}
          {children}
        </div>
        <div>{aside}</div>
      </div>
    </div>
  );
}
